import { render, staticRenderFns } from "./SimsAdd.vue?vue&type=template&id=b7070d78"
import script from "./SimsAdd.vue?vue&type=script&lang=js"
export * from "./SimsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports